// extracted by mini-css-extract-plugin
module.exports = {"root":"Shadown_root__NbaR9","low":"Shadown_low__JHGks","medium":"Shadown_medium__Zaw5R","high":"Shadown_high__U_4p6","highUp":"Shadown_highUp__wYaWp"};